import { exportIntakes } from '../services/api';
import { downloadResponseAsFile } from './downloadFile';
import type { IntakeFilters } from '../hooks/useIntake';

/**
 * A failed export response, shaped so the `apiErrorDetail` helpers can read the
 * status and the (Blob) error body off it.
 */
export class IntakeExportError extends Error {
  readonly response: unknown;
  readonly error: unknown;

  constructor(result: { error?: unknown; response?: unknown }) {
    super('Export failed');
    this.name = 'IntakeExportError';
    this.response = result.response;
    this.error = result.error;
  }
}

export async function downloadIntakeExport(
  filters: IntakeFilters
): Promise<void> {
  const response = await exportIntakes({
    query: {
      search: filters.search || undefined,
      start_date: filters.startDate || undefined,
      end_date: filters.endDate || undefined,
      intake_status: filters.statuses,
      clinic_id: filters.clinicId || undefined,
      assignee_ids: filters.assigneeIds,
      include_unassigned: filters.assigneeIncludeUnassigned || undefined,
      sort_by: filters.sortBy,
      sort_order: filters.sortOrder,
    },
    responseType: 'blob',
  });

  if (response.error) {
    // Carry the response through so the caller can read a 4xx business message
    // (e.g. the row-limit refusal) with getUserFacingApiMessageAsync. The body
    // is a Blob because of responseType: 'blob'.
    throw new IntakeExportError(response);
  }

  downloadResponseAsFile(response, 'RogerIntakeExport.xlsx');
}
